import { useId, type ReactNode } from 'react';
import { useI18n } from './I18nProvider.js';
import type { SupportedLocale } from '@mailbutler/i18n';

export function LanguagePicker(): ReactNode {
  const { locale, setLocale, availableLocales, localeNames, t } = useI18n();
  const id = useId();

  return (
    <div className="field">
      <label htmlFor={id}>{t('common.language')}</label>
      <select
        id={id}
        className="select"
        value={locale}
        onChange={(event) => setLocale(event.target.value as SupportedLocale)}
      >
        {availableLocales.map((value) => (
          <option key={value} value={value}>
            {localeNames[value]}
          </option>
        ))}
      </select>
    </div>
  );
}
